import React from 'react'
import {isEmpty} from 'lodash';
import './_style.scss';

const CadenasProduct = (props) => {

  var {
    cadenasFrame,
    ...heroContentProps
  } = props.data;

  // set component class
  const compClassName = '';
  const compClass = props.className !== undefined ? compClassName + ' ' + props.className : compClassName;


  return (

    <div comp="product-advanced-view" className={'product-advanced-view' + compClass}>

      <div className="responsive-iframe">
        <iframe
          id="advanced-view"
          title="Gefran product advanced view"
          src={cadenasFrame || ""}
          className="show"
          width="100%"
          height="auto"
          frameBorder="0"/>
      </div>

    </div>

  );

};

export default CadenasProduct;

// CONSIDER THIS WAY TO GET THE IFRAME HEIGHT

// PostMessage API:
//
//     The content inside the iframe can send a message to the parent window using the postMessage method.
//     The parent window can listen for this message and retrieve the height from the message data.
//     This requires cooperation from the iframe's source (i.e., you need control over or collaboration with the content being loaded in the iframe).

// // Inside the iframe content (cross-origin source)
// window.parent.postMessage({
//     height: document.documentElement.scrollHeight,
//     message: "iframeHeight"
// }, "*");
//
// // On the parent page
// window.addEventListener("message", function(event) {
//     if (event.data.message === "iframeHeight") {
//         let iframeHeight = event.data.height;
//         console.log("Iframe height:", iframeHeight);
//     }
// });
